import React from 'react';
import { Link } from 'react-router-dom';
import lax from 'lax.js';
import LaxDiv from '../Shared/LaxDiv';
 
class Speakers extends React.Component {

    constructor(props) {
        super(props)
        lax.setup()
    
        document.addEventListener('scroll', function(x) {
            lax.update(window.scrollY)
        }, false)
    
        lax.update(window.scrollY)
    }
    render(){
        const data = [require("../../assets/images/venue/1.webp"),require("../../assets/images/venue/2.webp"),require("../../assets/images/venue/3.webp"),require("../../assets/images/venue/4.webp")];
        return (
            <section id="venue" className="speakers-area ptb-120 pb-20">
                <div className="container">
                    <div className="section-title">
                        <span>Venue</span>
                        <h2>Sandipani Learning and Development Centre</h2>
                        <div className="bar"></div>
                        <LaxDiv text="Venue" dataPreset="driftRight" />
                        {/* <Link to="#" className="btn btn-primary">View More Speakers</Link> */}
                    </div>
                </div>

                <div className="row m-0">
                    {data.map((i, index) => 
                        <div className="col-lg-3 col-sm-6 p-0" key={index}>
                        <div className="elkevent-single-speakers" >
                            <img src={i} style={{ height:'300px', objectFit: 'cover'}} alt="speaker" />

                         
                        </div>
                    </div>
                    )}
                    
                </div>
                {/* <div className="speakers-content">
                                <h3><Link to="#">James Anderson</Link></h3>
                                <span>Founder & CEO</span>
                            </div> 
                             <ul>
                                <li>
                                    <Link to="#" target="_blank" className="facebook">
                                        <i className="icofont-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="twitter">
                                        <i className="icofont-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="instagram">
                                        <i className="icofont-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" target="_blank" className="linkedin">
                                        <i className="icofont-linkedin"></i>
                                    </Link>
                                </li>
                            </ul>  */}
            </section>
        );
    }
}
 
export default Speakers;